import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPauseCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 192,
	height: 192,
	fill: "#9ca3af",
	viewBox: "0 0 256 256",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 256,
		height: 256,
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z" })]
});
export { SvgPauseCircle as ReactComponent };
